import './bgcmartin/style';
import FormStructure from './bgcmartin/form_structure';

export default FormStructure;